import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectConfigurationParameterById } from '!core/redux';

export function useSendOtpBtn() {
  const [isSendOtpBtnOnHold, setIsSendOtpBtnOnHold] = useState(false);

  const onHoldButtonTimer = useRef(null);

  const otpOnHoldTime = useSelector((state) =>
    selectConfigurationParameterById(state, 'OTP_SEND_INTERVAL'),
  )?.value;

  const otpOnHoldTimeMs = Number(otpOnHoldTime) * 1000;

  const disableSendOtpButton = () => {
    setIsSendOtpBtnOnHold(true);
  };

  const enableSendOtpButtonWithDelay = () => {
    onHoldButtonTimer.current = setTimeout(() => {
      setIsSendOtpBtnOnHold(false);
    }, otpOnHoldTimeMs);
  };

  useEffect(() => {
    return () => {
      clearTimeout(onHoldButtonTimer.current);
    };
  }, []);

  return {
    isSendOtpBtnOnHold,
    disableSendOtpButton,
    enableSendOtpButtonWithDelay,
  };
}
